module.exports = __webpack_public_path__ + "static/media/eu.pictogram.529f17b0.svg";